// export default {
//
//   dev: {
//     host: "http://admin.3adiaoding.test/api",
//     category_id: "1",
//   },
//   pro: {
//     host: "https://backend.177xz.com/api",
//     category_id: "1",
//   }
// }


export default {
  dev: {
    host: "http://admin.3adiaoding.test/api",
    category_id: "1",
    img_prefix: "https://3adiaoding.oss-cn-hangzhou.aliyuncs.com/uploads/",
  },
  pro: {
    host: "https://backend.177xz.com/api",
    category_id: "1",
    img_prefix: "https://3adiaoding.oss-cn-hangzhou.aliyuncs.com/uploads/",
  }
}



// WEBPACK FOOTER //
// ./src/env.js